import { matchPath } from 'react-router';
import { REHYDRATE } from 'redux-persist';
import { PayloadAction } from '@reduxjs/toolkit';

import { UNSUPPORTED_BROWSER_BANNER_DISMISSED_KEY } from './constants';

export const waitForConnectionEvent = (signal: AbortSignal) => new Promise((resolve) => {
  const onlineHandler = () => resolve(true);
  const offlineHandler = () => resolve(false);

  window.addEventListener('online', onlineHandler, { once: true });
  window.addEventListener('offline', offlineHandler, { once: true });

  signal.addEventListener('abort', () => {
    window.removeEventListener('online', onlineHandler);
    window.removeEventListener('offline', offlineHandler);
    resolve(true);
  });
});

export const isRehydrateOnHome = (action: PayloadAction) => {
  const isHomeLocation = matchPath('/', window.location?.pathname ?? '');
  return action.type === REHYDRATE && Boolean(isHomeLocation);
};

// localStorage throws when it is blocked (Safari private mode, disabled site data): the banner then shows again
export const readUnsupportedBrowserBannerDismissal = (): boolean => {
  try {
    return localStorage.getItem(UNSUPPORTED_BROWSER_BANNER_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeUnsupportedBrowserBannerDismissal = (): void => {
  try {
    localStorage.setItem(UNSUPPORTED_BROWSER_BANNER_DISMISSED_KEY, 'true');
  } catch {
    // Blocked storage: the banner only closes until the next reload
  }
};
